export class ActionStatus {
    Id: number;
    MobileNo: number;
    ActionId: number;
    Status: number;
    Comment: string;
}





// WEBPACK FOOTER //
// ./src/app/shared/action-status.ts